import "./styles.styl";
import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Template from "./PaymentElementStripe.jsx";
import { useIntl } from "react-intl";

const STRIPE_PUBLIC_KEY = PROPS.STRIPE_PUBLIC_KEY;
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

export default function ProviderStripeController(props) {
  const intl = useIntl();
  const [stripe, setStripe] = useState(null);
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    fetch("/api/stripe/create-setup-intent", { method: "POST" })
      .then((res) => res.json())
      .then((data) => {
        setClientSecret(data.client_secret);

        if (!stripe) {
          stripePromise.then((stripeInstance) => {
            setStripe(stripeInstance);
          });
        }
      })
      .catch((error) => {
        console.error("Failed to initialize payment:", error);
      });
  }, [stripe]);

  if (!stripe) return null;

  return (
    <>
      {clientSecret && stripe && (
        <Elements
          stripe={stripe}
          options={{
            clientSecret,
            locale: intl.locale,
            loader: "always",
          }}
        >
          <Template {...props} stripe={stripe} />
        </Elements>
      )}
    </>
  );
}
